import React from 'react';
import { getIntl } from '../../../../../../utils/intl';
import Text from '../../../../../v2BaseComponents/Text';
import { StyleProp, ViewStyle } from 'react-native';
import PromptButton from '../../../../../shared/PromptButton';
import { useIsMobileLayout } from '../../../../../../hooks/useIsMobileLayout';

const intl = getIntl('chatInformationNotification', {
    buttonTitle: 'Responses are generated by AI',
    mobileButtonTitle: 'AI-generated content',
    learnMore: 'Learn more',
    disclaimerTitle: 'About this content',
    disclaimerContent:
        'This content has been generated by an artificial intelligence language model. While we strive for accuracy and quality, please note that the information provided may not be entirely error-free or up-to-date. We recommend independently verifying the content and consulting with professionals for specific advice or information. We do not assume any responsibility or liability for the use or interpretation of this content.',
});

type ChatInformationNotificationProps = {
    style?: StyleProp<ViewStyle>;
};

const InformationNotification: React.FC<ChatInformationNotificationProps> = ({}) => {
    const isMobile = useIsMobileLayout();
    return (
        <PromptButton
            buttonProps={{
                variant: 'ghost',
                leftIcon: 'Info',
                title: intl(isMobile ? 'mobileButtonTitle' : 'buttonTitle'),
                testID: 'chat-disclaimer-prompt-button',
            }}
            promptTitle={intl('disclaimerTitle')}
            renderPromptContents={() => <Text variant="body-1">{intl('disclaimerContent')}</Text>}
        />
    );
};

export default React.memo(InformationNotification);
